import React from 'react';
import classNames from 'classnames';
import TriggerNotificationPopover from './popovers/TriggerNotificationPopover';
import SharePopover from './popovers/SharePopover';
import CommentPopover from './popovers/CommentPopover';
import HighlightPopover from './popovers/HighlightPopover';
import ScorecardPopover from './popovers/ScorecardPopover';
import FeedbackRequestedPopover from './popovers/FeedbackRequestedPopover';
import ListenPopover from './popovers/ListenPopover';
import PopoverContainer from 'components/pure/utils/PopoverContainer';
import {List} from 'immutable';
import {ShareIcon} from '@components/icon/ShareIcon';
import {CommentIcon} from '@components/icon/CommentIcon';
import {ScorecardIcon} from '@components/icon/ScorecardIcon';
import {HeadphonesIcon} from '@components/icon/HeadphonesIcon';
import {HighlightIcon} from '@components/icon/HighlightIcon';
import {BellIcon} from '@components/icon/BellIcon';
import {OverlappingCommentsIcon} from '@components/icon/OverlappingCommentsIcon';
import './HistoryItemMarkers.styl';

export default class HistoryItemMarkers extends React.PureComponent {
  getColumns() {
    return [
      {
        types: ['call_shared', 'call_i_shared'],
        icon: ShareIcon,
        popover: SharePopover,
        disabledTooltip: 'Not shared',
      },
      {
        types: ['trigger_notification'],
        icon: BellIcon,
        popover: TriggerNotificationPopover,
        disabledTooltip: 'No smart alerts',
      },
      {
        types: ['comment_given', 'comment_received'],
        icon: CommentIcon,
        popover: CommentPopover,
        disabledTooltip: 'No comments',
      },
      {
        types: ['highlight_received', 'highlight_given'],
        icon: HighlightIcon,
        popover: HighlightPopover,
        disabledTooltip: 'No highlights',
      },
      {
        types: ['scores_received', 'scores_given'],
        icon: ScorecardIcon,
        popover: ScorecardPopover,
        disabledTooltip: 'No scores',
      },
      {
        types: ['listened'],
        icon: HeadphonesIcon,
        popover: ListenPopover,
        disabledTooltip: 'Has not listened',
      },
      {
        types: ['feedback_requested', 'feedback_i_requested'],
        icon: OverlappingCommentsIcon,
        popover: FeedbackRequestedPopover,
        disabledTooltip: 'No coaching requested',
      },
    ].map(column => ({...column, types: List(column.types)}));
  }

  render() {
    const {items} = this.props;

    const itemsByType = items.groupBy(item => item.context.type);

    return (
      <ul className="history-item-markers">
        <PopoverContainer
          className="ev-tooltip-control ev-tooltip history-item-actions"
          ref={r => (this.popoverContainer = r)}
          anchorOriginVertical={'center'}
          hideEmpty
        />
        {this.getColumns().map(column => {
          const items = column.types
            .map(type => itemsByType.get(type))
            .flatten()
            .filter(items => !!items);
          return (
            <li
              key={column.types.join('-')}
              className={'click-target-popover'}
              ref={r =>
                r &&
                this.popoverContainer.registerPopoverItem(r, () => {
                  // important: hideEmpty on the container and this failsafe
                  // prevent continuing to show the tooltip when
                  // all items have been cleared.
                  if (!items || items.size === 0) {
                    return (
                      <div className="scroll-control-wrapper">
                        <h2 className="disabled-tooltip">{column.disabledTooltip}</h2>
                      </div>
                    );
                  }

                  return (
                    <div className="scroll-control-wrapper">
                      <column.popover
                        items={items}
                        fileUploadId={this.props.fileUploadId}
                        newCallCard={this.props.newCallCard}
                      />
                    </div>
                  );
                })
              }>
              <column.icon className={classNames({active: items.size > 0})} />
            </li>
          );
        })}
      </ul>
    );
  }
}
